import { CREDIT_PRODUCT } from 'api/advances'
import { SimpleArrowIcon } from 'assets/icons'
import HelpIcon from 'assets/icons/HelpIcon'
import { ProgressBar } from 'components/AdvanceOffer'
import { RejectedLineModal } from 'components/LineModals'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useActiveCreditsStore } from 'store'
import { LineSummary } from 'types/api/loan'
import { toLocaleCurrency } from 'utils/dinero'

const { LOANS } = CREDIT_PRODUCT

const ProgressComponent = ({
  type,
  summary,
  className = ''
}: {
  type: keyof typeof CREDIT_PRODUCT
  summary: LineSummary
  className?: string
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const navigate = useNavigate()

  const { activeAdvances, activeLoans } = useActiveCreditsStore()

  const allocatedAmountFromOtherPeriod =
    CREDIT_PRODUCT[type] === LOANS
      ? activeLoans?.reduce(
          (acc, item) =>
            acc +
            (item.was_requested_in_last_credit_line
              ? 0
              : item.delivered_amount),
          0
        )
      : activeAdvances?.reduce(
          (acc, item) =>
            acc +
            (item.was_requested_in_last_credit_line
              ? 0
              : item.delivered_amount),
          0
        ) ?? 0

  if (summary.approvedAmount <= 0)
    return (
      <>
        <div className={`w-full flex gap-2 items-center ${className}`}>
          <div className='w-full'>
            <h4 className='text-2xs font-bold'>
              {' '}
              {CREDIT_PRODUCT[type] === LOANS ? 'Préstamos' : 'Adelantos'}
            </h4>
            <p className='text-left font-medium text-[10px]'>
              Por el momento no podemos ofrecerte nuevos{' '}
              {CREDIT_PRODUCT[type] === LOANS ? 'préstamos' : 'adelantos'}.
            </p>
          </div>
          <button
            type='button'
            onClick={() => setIsModalOpen(true)}
            className={`flex shrink-0 justify-center items-center w-6 h-6 rounded-full bg-purple-900
  }`}
          >
            <p className='sr-only'>?</p>
            <HelpIcon />
          </button>
        </div>
        <RejectedLineModal
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          isLoan={CREDIT_PRODUCT[type] === LOANS}
        />
      </>
    )

  return (
    <div className={`w-full flex gap-2 items-center ${className}`}>
      <div className='w-full'>
        <h4 className='text-2xs font-bold'>
          {CREDIT_PRODUCT[type] === LOANS ? 'Préstamos' : 'Adelantos'}
        </h4>
        <ProgressInfo
          allocated={
            summary.allocatedAmount < 0
              ? 0
              : summary.allocatedAmount + allocatedAmountFromOtherPeriod
          }
          approved={
            summary.approvedAmount < 0
              ? 0
              : summary.approvedAmount + allocatedAmountFromOtherPeriod
          }
        />
      </div>
      <Button
        action={() =>
          navigate(
            `/perfil-crediticio/detalle-de-linea/${
              CREDIT_PRODUCT[type] === LOANS ? 'prestamos' : 'adelantos'
            }`
          )
        }
      />
    </div>
  )
}

export default ProgressComponent

const Button = ({ action }: { action: () => void }) => (
  <button
    type='button'
    onClick={() => action()}
    className={`flex shrink-0 justify-center items-center w-6 h-6 rounded-full bg-purple-900
  }`}
  >
    <p className='sr-only'>➡</p>
    <SimpleArrowIcon stroke='#FFFFFF' />
  </button>
)

export const ProgressInfo = ({
  allocated,
  approved,
  className = '',
  barClassName = '',
  barBgClassName = ''
}: {
  allocated: number
  approved: number
  className?: string
  barClassName?: string
  barBgClassName?: string
}) => (
  <div className={`w-full text-left font-medium text-[10px] ${className}`}>
    <ProgressBar
      bgClassName={`bg-green-900 ${barBgClassName}`}
      className={`my-2 w-full ${barClassName}`}
      value={allocated}
      maxValue={approved}
    />
    <p>
      ${toLocaleCurrency(allocated)} utilizados de ${toLocaleCurrency(approved)}{' '}
      disponibles
    </p>
  </div>
)
